var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navBar',[_c('div',{staticClass:"pages"},[_c('div',{staticClass:"mt40 title"},[_vm._v(" "+_vm._s(_vm.detail.title)+" ")]),_c('div',{staticClass:"time mt10"},[_vm._v(" "+_vm._s(_vm.detail.createdTime)+" ")]),_c('div',{staticClass:"container mt20",domProps:{"innerHTML":_vm._s(_vm.detail.content)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }